import React, {useState} from 'react'
import {Redirect, Link} from 'react-router-dom'

import {Button, Typography, FormHelperText, Grid} from '@material-ui/core/'

import {useFormReducerHook} from '../../utils/customHooks'
import {useSettings} from '../../utils/Settings'
import FormBuilder from '../../components/FormBuilder'
import Loader from '../../components/Loader'
import {getOuterAuthenticate} from '../../services/outReach'

const SignIn = props => {
    const {
        formData,
        updateFormData: setFormData,
        errorsData,
        updateValidationData,
        validationData,
        validate,
        updateEntireFormData,
    } = useFormReducerHook()
    const {appConfig} = useSettings()
    const [updateError, setUpdateError] = useState('')
    const [loading, setLoading] = useState(false)
    const [redirect, setRedirect] = useState(!appConfig.checkAuthMode)
    const [redirectToSignup, setRedirectToSignup] = useState(false)
    const [signupmemberloading, setSignupMemberLoading] = useState(false)

    const actionMethods = (type, payload) => {
        switch (type) {
            case 'enterOnKeyUp':
                //submitForm()
                break
            default:
                break
        }
    }

    const submitForm = async () => {
        if (validate()) {
            setLoading(true)
            const result = await getOuterAuthenticate({
                loginname: formData.username.trim(),
            })
            if (Object.keys(result.error).length > 0) {
                setUpdateError(result.error.message)
                setLoading(false)
            } else {
                if (result && result.success.url && result.success.url.length > 0) {
                    window.location.assign(result.success.url)
                } else {
                    setLoading(false)
                    updateEntireFormData({...formData, password: ''})
                    setRedirect(true)
                }
            }
        }
    }

    const RegistrationAsMember = async () => {
        setSignupMemberLoading(true)
        const result = await getOuterAuthenticate()
        if (Object.keys(result.error).length > 0) {
            setUpdateError(result.error.message)
            setLoading(false)
        } else {
            if (result && result.success.url && result.success.url.length > 0) {
                window.location.assign(result.success.url)
            }
        }
        setSignupMemberLoading(false)
    }

    const loginPath =
        process.env.REACT_APP_ISMYACCOUNT === 'yes' ? '/login-my-account' : '/login'

    if (redirect) return <Redirect to={{pathname: loginPath, state: formData}} />
    if (redirectToSignup) return <Redirect to={{pathname: '/'}} />

    return (
        <React.Fragment>
            <Grid item className="login__contanier  signup-registration__form">
                <Grid item className="login__signin">
                    <FormBuilder
                        fields={appConfig.signInFormProps}
                        formData={formData}
                        setFormData={setFormData}
                        errorsData={errorsData}
                        updateValidation={updateValidationData}
                        onSubmit={submitForm}
                        actionMethods={actionMethods}
                    />

                    <FormHelperText error>{updateError}</FormHelperText>
                </Grid>
                <Grid item xs className="login__form-action">
                    <Grid item xs={12} className="loader__container">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={submitForm}
                            disabled={loading}
                        >
                            {appConfig.supportedLabels.signin.submitBtnTxt}
                        </Button>
                        {loading ? <Loader /> : null}
                    </Grid>

                    <Grid item xs={12} className="bottom-link__container">
                        <Grid item xs={12} class="login__form-bottom-action">
                            <p class="">New user?</p>
                        </Grid>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={RegistrationAsMember}
                        >
                            {appConfig.supportedLabels.signin.signupMemberBtnTxt}
                        </Button>
                        {signupmemberloading ? <Loader /> : null}
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setRedirectToSignup(true)}
                        >
                            {appConfig.supportedLabels.signin.signupNonMemberBtnTxt}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export default SignIn
